// extracted by mini-css-extract-plugin
module.exports = {"Canvas":"FieldTextCanvas_Canvas__1hf9S"};